import React, { useRef, useState } from 'react';
import axios from "axios";
import InvestmentProposalQuote from './InvestmentProposalQuote';
import InvestmentProposalDetails from './InvestmentProposalDetails';
import editDetails from '../Investment/Images/Group1510.svg';
import Male from '../Investment/Images/Group3635.svg';
import Female from '../Investment/Images/Group3639.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { CountYear, CommaSeprator, getAge } from './UtilityComponents/UtilityFunction';
import { MdKeyboardArrowRight } from "react-icons/md";
import { basePath } from '../index';
import { useEffect } from 'react';
import ShareQuotations from './ShareQuotations/ShareQuotations';
import downloadBrochure from "./Images/Icon-feather-download.svg";

const InvestmentProposal = (props) => {
    const ref = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const [BuyData, setBuyData] = useState(null);
    const [QuoteReq, setQuoteReq] = useState(null);
    const [MaritalList, setMaritalList] = useState([]);
    const [OccupationList, setOccupationList] = useState([]);
    const [EducationList, setEducationList] = useState([]);
    const [NomineeRelation, setNomineeRelation] = useState([]);

    const [CurrentLifeStageList, setCurrentLifeStageList] = useState([]);
    const [InvestmentObjectiveList, setInvestmentObjectiveList] = useState([]);
    const [RiskAppetiteList, setRiskAppetiteList] = useState([]);
    const [InsurancePortFolioAlreadyHeldList, setInsurancePortFolioAlreadyHeldList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    //const [BtnVal, setBtnVal] = useState("Continue");
    const [isFromShare, setIsFromShare] = useState(false);
    const [isFormFilled, setIsFormFilled] = useState(false);
    const [sharedProposalData, setSharedProposalData] = useState(null);
    const [email, setEmail] = useState('');
    const [BIURL, setBIURL] = useState('');





    const [BtnVal, setBtnVal] = useState(() => (
        <>
            Continue<MdKeyboardArrowRight className="ContinueArrow" />
        </>
    ));


    const generateRequestModel = (data) => {

        return {
            "EnquiryNo": QuoteReq.EnquiryNo,
            "InsurerId": BuyData.InsurerId,
            "FullName": data.Name,
            "Gender": QuoteReq.Gender,
            "DOB": QuoteReq.DOB,
            "MobileNo": data.MobileNo,
            "EmailID": data.Email,
            "Occupation": data.Occupation,
            "Education": data.Education,
            "StateName": data.StateName,
            "Pincode": data.PinCode,
            "PAN": data.PAN ?? null,
            "Address": data.Address,
            "MaritalStatus": data.MaritalStatus,
            "nomineeName": data.nomineeName ?? null,
            "nomineeAge": data.nomineeAge ?? null,
            "nomineeRelation": data.nomineeRelation ?? null,
            "PlanType": QuoteReq.PlanType,
            "PaymentTerm": QuoteReq.PaymentTerm,
            "ModelPremium": QuoteReq.ModelPremium,
            "PaymentFreq": QuoteReq.PaymentFreq,
            "QuoteNo": BuyData.QuoteID,
            "SumAssured": BuyData.SumAssured,
            "TranKey": BuyData.TranKey,
            "LotNo": BuyData.LotNo,
            ...(BuyData?.InsurerId === 156 && {
                CurrentLifeStage: data.currentLifeStage,
                InvestmentObjective: data.investmentObjective,
                RiskAppetite: data.riskAppetite,
                InsurancePortfolioAlreadyHeld: data.insurancePortFolioAlreadyHeld
            })
        }
    }

    const handleSubmit = (data) => {

        setBtnVal("Wait...")
        const PropReq = {
            "EnquiryNo": QuoteReq.EnquiryNo,
            "InsurerId": BuyData.InsurerId,
            "FullName": data.Name,
            "Gender": QuoteReq.Gender,
            "DOB": QuoteReq.DOB,
            "MobileNo": data.MobileNo,
            "EmailID": data.Email,
            "Occupation": data.Occupation,
            "Education": data.Education,
            "StateName": data.StateName,
            "Pincode": data.PinCode,
            "PAN": data.PAN ?? null,
            "Address": data.Address,
            "MaritalStatus": data.MaritalStatus,
            "nomineeName": data.nomineeName ?? null,
            "nomineeAge": data.nomineeAge ?? null,
            "nomineeRelation": data.nomineeRelation ?? null,
            "PlanType": QuoteReq.PlanType,
            "PaymentTerm": QuoteReq.PaymentTerm,
            "ModelPremium": QuoteReq.ModelPremium,
            "PaymentFreq": QuoteReq.PaymentFreq,
            "QuoteNo": BuyData.QuoteID,
            "SumAssured": BuyData.SumAssured,
            "TranKey": BuyData.TranKey,
            "LotNo": BuyData.LotNo,
            ...(BuyData?.InsurerId === 156 && {
                CurrentLifeStage: data.currentLifeStage,
                InvestmentObjective: data.investmentObjective,
                RiskAppetite: data.riskAppetite,
                InsurancePortfolioAlreadyHeld: data.insurancePortFolioAlreadyHeld
            })
        }




        //axios.post(`api/Quotation/GotoProposal`, PropReq)
        axios.post(`central/centralcall/callreqwithheader`, { URL: "GoToProposal", Req: PropReq })
            .then(res => {
                if (res.data?.Data?.RedirectionUrl !== undefined && res.data?.Data?.RedirectionUrl !== null && res.data?.Data?.RedirectionUrl !== "") {
                    window.location.href = res.data.Data.RedirectionUrl;
                    setBtnVal("Continue >");
                } else {
                    alert(res.data?.ErrorMessage);
                    setBtnVal("Continue >");
                }

            }).catch(err => {
                //console.log(err); setBtnVal("Continue >")
            });

    }

    //const callMasterAPI = async () => {
    //    const masterKey = ["OCCUPATION_INV", "QUALIFICATION", "NOMINEERELATION", "MARITAL"];

    //    const data = await Promise.all(masterKey.map(r => axios.post(`central/centralcall/callreqwithheader`, { URL: "GetMaster", Req: { InsurerId: BuyData.InsurerId, MasterType: r } })));
    //    for (let i = 0; i < masterKey.length; i++) {
    //        switch (masterKey[i]) {
    //            case "OCCUPATION_INV":
    //                setOccupationList(data[i].data.Data);
    //                break;
    //            case "QUALIFICATION":
    //                setEducationList(data[i].data.Data);
    //                break;
    //            case "NOMINEERELATION":
    //                setNomineeRelation(data[i].data.Data);
    //                break;
    //            case "MARITAL":
    //                setMaritalList(data[i].data.Data);
    //                break;
    //            default:
    //                break;
    //        }

    //    }
    //}


    const callMasterAPI = async () => {
        let masterKey = ["OCCUPATION_INV", "QUALIFICATION", "NOMINEERELATION", "MARITAL"];


        if (BuyData?.InsurerId == 156) {
            masterKey.push("CurrentLifeStage", "InvestmentObjective", "RiskAppetite", "InsurancePortFolioAlreadyHeld");
        }

        const data = await Promise.all(
            masterKey.map(r =>
                axios.post(`central/centralcall/callreqwithheader`, {
                    URL: "GetMaster",
                    Req: {
                        InsurerId: BuyData.InsurerId,
                        MasterType: r
                    }
                })
            )
        );

        for (let i = 0; i < masterKey.length; i++) {
            switch (masterKey[i]) {
                case "OCCUPATION_INV":
                    setOccupationList(data[i].data.Data);
                    break;

                case "QUALIFICATION":
                    setEducationList(data[i].data.Data);
                    break;

                case "NOMINEERELATION":
                    setNomineeRelation(data[i].data.Data);
                    break;

                case "MARITAL":
                    setMaritalList(data[i].data.Data);
                    break;

                // 🔽 New masters (only for insurer 156)
                case "CurrentLifeStage":
                    setCurrentLifeStageList(data[i].data.Data);
                    break;

                case "InvestmentObjective":
                    setInvestmentObjectiveList(data[i].data.Data);
                    break;

                case "RiskAppetite":
                    setRiskAppetiteList(data[i].data.Data);
                    break;

                case "InsurancePortFolioAlreadyHeld":
                    setInsurancePortFolioAlreadyHeldList(data[i].data.Data);
                    break;

                default:
                    break;
            }
        }
    };






    const getSharedProposal = () => {
        setIsFromShare(true);
        const prm = new URLSearchParams(window.location.search);
        let model = {};
        if (prm.has('shareid') || prm.has('shareId')) {
            const shareId = prm.has("shareid") ? prm.get("shareid") : prm.get("shareId");
            let shareNewId = prm.has("shareid") ? prm.get("shareid") : prm.get("shareId");
            //shareNewId = shareNewId.replace("P", "")
            model = { URL: "GetShareDetails", Req: { shareToken: decodeURIComponent(shareNewId), Stage: "PROPOSAL" } }
        } else {
            const enqNo = prm.has('enquiryno') ? prm.get('enquiryno') : prm.get('enquiryNo')
            model = { URL: "GetProposalPolicyDetailsByEnqNo", Req: { EnquiryNo: enqNo } }
        }
        axios.post('central/centralcall/callreqwithheader', model).then(Res => {
            if (Res.data.StatusCode === 200) {
                const data = Res.data.Data;
                const QuoteReq = data.SaveEnquiryRequest;
                const QuoteRes = data.QuotationRequestAndResponse[0]?.QuotationResponse;
                QuoteReq.DOB = QuoteRes.DoB;
                QuoteReq.Age = getAge(QuoteRes.DoB);
                setBuyData(QuoteRes);
                setQuoteReq(QuoteReq)
                setSharedProposalData(Res.data.Data);
                setBIURL(data.QuotationRequestAndResponse[0]?.QuotationResponse?.PDFUrl);
                //console.log(data.Quotations[0]?.QuotationResponse?.PDFUrl, "prop BI")

            }
        }).catch(error => console.log({ error }));
    }


    const shareProposal = () => {
        const propFormData = ref.current.getProposalFormData();
        const sharePropRequest = generateRequestModel(propFormData);
        setEmail(propFormData.Email);

        axios.post('central/centralcall/callreqwithheader', { URL: 'ShareProposal', Stage: "PROPOSAL", Req: sharePropRequest })
            .then(Res => {
                if (Res.data.StatusCode === 200) {
                    setShowModal(true);
                }
            }).catch(error => console.log({ error }));
    }

    useEffect(() => {
        const prm = new URLSearchParams(window.location.search);
        if (prm.has('shareid') || prm.has('shareId') || prm.has('enquiryno') || prm.has('enquiryNo')) {
            getSharedProposal();
        } else {
            const state = location.state;
            if (!state) {
                return;
            }
            setBuyData(state.BuyData);
            setQuoteReq(state.QuoteReq);
            setBIURL(state.BIURL);
        }

    }, []);


    useEffect(() => {
        if (BuyData && QuoteReq) {
        callMasterAPI();
        }
    }, [BuyData, QuoteReq]);
    return (
        <>
            <div className="ProposalBoxMainBox">
                <div className="container">
                    <div className="NewProposal">
                        <div className="container">
                            <div className="proposalPageBox">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-between">
                                        <div className="BackBTNRow">
                                                {!isFromShare && <a className="arw-btn" onClick={() => navigate(-1)}>
                                                <i className="fas fa-long-arrow-alt-left"></i>
                                                <span className="BackToQuote">&nbsp;&nbsp;Back to Quotation</span>
                                            </a>}
                                        </div>
                                            <div className="ReverseBTNRow">
                                                <button className="arw-right" disabled={!isFormFilled}  onClick={() => shareProposal()}>
                                                <i class="fas fa-share-alt"></i>
                                                <span className="mx-1">Share Proposal</span>
                                            </button>
                                            </div>
                                        </div>
                                        {showModal && <ShareQuotations showModal={showModal} ShareFor="PROPOSAL" EnquiryNo={BuyData?.EnquiryNo} LotNo={BuyData?.LotNo} MobileNo={QuoteReq.MobileNo} Email={email} hiddenQuotes={props.hiddenQuotes ?? []} closeModal={() => setShowModal(false)} />}
                                        {/*{showModal && <ShareQuotations key={email || QuoteReq?.EmailID || "proposal-share"} showModal={showModal} ShareFor="PROPOSAL" EnquiryNo={BuyData?.EnquiryNo} LotNo={BuyData?.LotNo} MobileNo={QuoteReq.MobileNo} Email={email || QuoteReq?.EmailID || ""} hiddenQuotes={props.hiddenQuotes ?? []} closeModal={() => setShowModal(false)} />}*/}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="ProposalDetails">
                                            <div className="t-inputs2">
                                                <label className="InvestSelect"> {QuoteReq?.Gender === "M" ? <img src={Male} className="IconPic" /> : <img src={Female} className="IconPic" />}{QuoteReq?.Age}  yrs, {QuoteReq?.Gender === "M" ? "Male" : "Female"}</label>
                                                <label className="AllLabel Proposal">Your details</label>
                                            </div>
                                            <div className="t-inputs2">
                                                <label className="InvestSelect">
                                                    ₹{CommaSeprator(BuyData?.ModelPremium)} / {QuoteReq?.PaymentFreq === "Y" ? "yearly" : "" ||
                                                        QuoteReq?.PaymentFreq === "M" ? "monthly" : "" ||
                                                            QuoteReq?.PaymentFreq === "Q" ? "quarterly" : "" ||
                                                                QuoteReq?.PaymentFreq === "H" ? "half yearly" : ""}
                                                </label>
                                                <label className="AllLabel Proposal">Investment amount</label>
                                                <span className="dividerLine"></span>
                                            </div>
                                            <div className="t-inputs2">
                                                <label className="InvestSelect">{QuoteReq?.PaymentTerm} years</label>

                                                <label className="AllLabel Proposal">Pay for</label>
                                                <div className="DateTicksss PmtTrm"> till {CountYear(QuoteReq?.PaymentTerm)}</div>
                                                <span className="dividerLine"></span>
                                            </div>
                                            <div className="t-inputs2">
                                                <label className=" InvestSelect">{QuoteReq?.PolicyTerm} years</label>
                                                <label className="AllLabel Proposal">Maturity after</label>
                                                <div className="DateTicksss PmtTrm"> till {CountYear(QuoteReq?.PolicyTerm)}</div>
                                                <span className="dividerLine"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <InvestmentProposalDetails
                                            ref={ref} sharedProposalData={sharedProposalData}
                                            setIsFormFilled={(flag) => setIsFormFilled(flag)}
                                            submitForm={handleSubmit} BtnVal={BtnVal} QuoteReq={QuoteReq}
                                            BuyData={BuyData} MaritalList={MaritalList ?? []}
                                            OccupationList={OccupationList ?? []} EducationList={EducationList ?? []}
                                            NomineeRelation={NomineeRelation ?? []}
                                            currentLifeStageList={CurrentLifeStageList ?? []}
                                            investmentObjectiveList={InvestmentObjectiveList ?? []}
                                            riskAppetiteList={RiskAppetiteList ?? []}
                                            insurancePortFolioAlreadyHeldList={InsurancePortFolioAlreadyHeldList ?? []}

                                        />
                                    </div>

                                    <div className="col-md-3" >
                                        <InvestmentProposalQuote BuyData={BuyData} />
                                        {BIURL && <div className="BIPdfDld">
                                            <a href={BIURL} target="_blank">
                                                <span className="InvestFormat mx-1">Benefit Illustration</span>
                                                <img src={downloadBrochure} className="IconPic" />
                                            </a>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
}

export default InvestmentProposal;
